// extracted by mini-css-extract-plugin
export default {"submitButton":"ActivateTelegramBot_submitButton__R13m4","link":"ActivateTelegramBot_link__A0thm","description":"ActivateTelegramBot_description__Ld4kV"};